import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

const ADMIN_TOKEN_KEY = "lykit_admin_token";

export const getAdminToken = () => {
  try {
    return window.localStorage.getItem(ADMIN_TOKEN_KEY) || "";
  } catch (e) {
    return "";
  }
};

export const setAdminToken = (token) => {
  try {
    if (token) window.localStorage.setItem(ADMIN_TOKEN_KEY, token);
    else window.localStorage.removeItem(ADMIN_TOKEN_KEY);
  } catch (e) {
    /* ignore */
  }
};

export const adminHeaders = (token) => ({
  headers: { "X-Admin-Token": token || getAdminToken() },
});

export const extractError = (error, fallback = "Something went wrong. Please try again.") => {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail) && detail.length) {
    const first = detail[0];
    const field = Array.isArray(first?.loc) ? first.loc[first.loc.length - 1] : "";
    return `${field ? `${field}: ` : ""}${first?.msg || fallback}`;
  }
  return error?.message === "Network Error" ? "Network error. Please check your connection." : fallback;
};

/* ------------------------------------------------------------------ public API */
export const fetchProjects = (category) =>
  api.get("/projects", { params: category && category !== "ALL" ? { category } : {} }).then((r) => r.data);

export const fetchProject = (slug) => api.get(`/projects/${slug}`).then((r) => r.data);
export const fetchPartners = () => api.get("/partners").then((r) => r.data);
export const fetchOpenings = () => api.get("/openings").then((r) => r.data);

export const postEnquiry = (payload) => api.post("/enquiries", payload).then((r) => r.data);
export const postApplication = (payload) => api.post("/applications", payload).then((r) => r.data);
export const postCampaign = (payload) => api.post("/campaigns", payload).then((r) => r.data);
export const postPartnerRequest = (payload) => api.post("/partner-requests", payload).then((r) => r.data);
